import Measurement from "@/sites/measurements/measurement";
import { columns } from "./table-config";

/**
 * This component is just a wrapper to embed it into the project panel.
 * The Measurement component should also be used as a standalone component on a different route.
 */

export function ProjectMeasurements() {
	/** Render */
	return (
		<Measurement
			type="manager"
			columns={columns}
		/>
	);
}
